
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import ListFilters from 'ah-common-lib/src/common/components/listing/ListFilters.vue';
import SizeSelector from 'ah-common-lib/src/common/components/SizeSelector.vue';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import { capitalize } from 'lodash';
import { OutstadingFee } from 'ah-api-gateways/models/feesAndCharges/fees';
import LoadingIcon from 'ah-common-lib/src/icons/components/LoadingIcon.vue';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';

// TODO composition API
@Component({ components: { SizeSelector, LoadingIcon } })
export default class SingleOwnerOutstandingFeesHeader extends Mixins(WithRequestManager, ListFilters) {
  @Prop({ required: true }) clientOrPartnerId!: string;

  @Prop({ required: true }) userType!: 'client' | 'partner';

  private pageSize = 10;

  private feesInformation: OutstadingFee[] | null = null;

  private numberOfRowsOptions: { label: string; value: number }[] = [
    { label: '10', value: 10 },
    { label: '20', value: 20 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
    { label: 'All', value: 100000 },
  ];

  formatCurrencyValue = formatCurrencyValue;

  get feesAccrued() {
    let feeAccrued = 0;
    this.feesInformation?.forEach((fee) => (feeAccrued += fee.feesAccrued));
    return feeAccrued;
  }
  get feesPaid() {
    let feesPaid = 0;
    this.feesInformation?.forEach((fee) => (feesPaid += fee.feesPaid));
    return feesPaid;
  }

  get feesOutstanding() {
    let feesOutstanding = 0;
    this.feesInformation?.forEach((fee) => (feesOutstanding += fee.feesOutstanding));
    return feesOutstanding;
  }

  get knownSortAndPageParams() {
    return [
      {
        key: 'pageSize',
        getter: () => this.pageSize || undefined,
        setter: (value: any) => (this.pageSize = value),
      },
    ];
  }

  @Watch('clientOrPartnerId', { immediate: true })
  @Watch('userType')
  onUserChanged() {
    this.feesInformation = null;
    const params: any = { type: `${this.userType}s` };
    params[`${this.userType}Id`] = this.clientOrPartnerId;

    this.requestManager
      .sameOrCancelAndNew(
        `get${capitalize(this.userType)}-${this.clientOrPartnerId}`,
        this.$ahTradesState.services.fees.listOutstandingFees(params)
      )
      .subscribe((response) => (this.feesInformation = response.list));
  }
}
